<template>
  <div id="Checkout">
    <div class="CheckOutForm">
      <div class="row">
        <div class="header">
          <router-link to="/">
            <img src="/img/logo.svg" />
          </router-link>
        </div>
        <UserDataForm
          v-model="user_data"
          :show="form_step == 'user'"
          v-on:change-step="form_step = 'pay'"
        />
        <PayDataForm
          v-model="user_payway"
          :show="form_step == 'pay'"
          :user_data="user_data"
          :payway_data="payway_data"
          :installment_fee="installment_fee"
          :total_price="total_price"
          v-on:change-step="form_step = 'user'"
          v-on:send-order="CheckShopCartAvalible"
        />
      </div>
    </div>

    <CheckOutShopCart
      :shipfee="shipfee"
      :user_payway="user_payway"
      :installment_fee="installment_fee"
      v-on:send-order="SendOrder"
      v-on:set-price="SetTotalPrice"
      ref="CheckOutShopCart"
    />

    <div class="header">
      <router-link to="/">
        <img src="/img/logo.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
import ZCPay from "@/common/zero_card.js";
import CheckOutShopCart from "@/components/CheckOut/CheckOutShopCart/";
import UserDataForm from "@/components/CheckOut/UserDataForm/";
import PayDataForm from "@/components/CheckOut/PayDataForm";
export default {
  name: "Checkout",
  components: {
    CheckOutShopCart,
    UserDataForm,
    PayDataForm,
  },
  mixins: [ZCPay],
  data() {
    return {
      form_step: "user",
      payway_data: [
        // {
        //   id: 4,
        //   title: '(7-11) 超商取貨付款 - Convenience Store Cash on Delivery',
        //   image: '',
        //   content:
        //     '台灣地區與離島地區皆可使用',
        //   type: 'C2C',
        //   cost: 65,
        // },
        {
          id: 1,
          title: "(宅配) 信用卡 - Credit card",
          image: "/img/card_icon.svg",
          content:
            "點選完成訂單後，您將會被引導至第三方加密付款頁以安全完成付款<br>台灣地區限定使用",
          type: "Credit",
          cost: 150,
        },
        {
          id: 6,
          title: "(宅配) 零卡分期 - 0 Card Pay",
          image: "/img/0_card.png",
          content: "台灣地區限定使用",
          type: "zero_card",
          cost: 150,
        },
        {
          id: 2,
          title: "(宅配) 轉帳/匯款 - ATM",
          image: "",
          content: "台灣地區限定使用",
          type: "ATM",
          cost: 150,
        },
        {
          id: 5,
          title: "(宅配) 超商代碼繳費 - Convenience Store Paycode",
          image: "",
          content: "台灣地區限定使用",
          type: "CVS",
          cost: 150,
        },
      ],
      user_data: {
        name: "",
        email: "",
        city: "",
        area: "",
        shop: "",
        address: "",
        phone: "",
        commit: "",
      },
      user_payway: {
        type: "Credit",
        installment: 3,
      },
      total_price: 0,
    };
  },
  methods: {
    SendOrder(total_price) {
      let data = {
        status: "W",
        name: this.user_data.name,
        email: this.user_data.email,
        phone: this.user_data.phone,
        address:
          this.user_data.city +
          "-" +
          this.user_data.area +
          "-" +
          this.user_data.address,
        comment: this.user_data.commit,
        payment: this.user_payway.type,
        shipping_fee: this.shipfee,
        discount: "0",
        total_price: parseInt(total_price) + parseInt(this.shipfee),
        products: this.$store.state.shopcart,
        installment: this.user_payway.installment,
        charge_fee: Math.ceil(
          this.installment_fee[this.user_payway.installment] *
            parseInt(total_price)
        ),
      };

      const form = document.createElement("form");
      form.method = "post";
      form.action = process.env.VUE_APP_BASE_API + "orders/create_order.php";

      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "order_data";
      hiddenField.value = JSON.stringify(data);
      form.appendChild(hiddenField);

      document.body.appendChild(form);
      form.submit();
    },
    CheckShopCartAvalible() {
      this.$refs.CheckOutShopCart.CheckOrder();
    },
    SetTotalPrice(val) {
      this.total_price = val;
    },
  },
  computed: {
    store_shopcart() {
      //判斷購物車是否為空使用
      return this.$store.state.shopcart;
    },
    shipfee() {
      return this.payway_data.filter(
        (item) => item.type == this.user_payway.type
      )[0].cost;
    },
  },
  watch: {
    store_shopcart() {
      if (this.store_shopcart.length <= 0) {
        this.$router.push("/");
      }
    },
    form_step() {
      document.getElementById("Checkout").scrollTo(0, 0);
    },
  },

  metaInfo() {
    return {
      title: "結帳｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "請先參閱隱私權政策與購物須知後再進行結帳",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "請先參閱隱私權政策與購物須知後再進行結帳",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "請先參閱隱私權政策與購物須知後再進行結帳",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "結帳｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "結帳｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "結帳｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
